import React from "react";
import styles from "./EmptyCart.module.css";

import { ReactComponent as CartIcon } from "./../../../../assets/svg/footer-cart.svg";
import { useTranslation } from "react-i18next";

const EmptyCart = () => {
  const { t } = useTranslation();

  return (
    <div className={`cart-empty-list ${styles.CartEmptyContainer}`}>
      <CartIcon className={styles.CartIcon} />
      <span>{t("emptycart.cart_empty")}</span>
    </div>
  );
};

export default EmptyCart;
